{{#if (equal resultText 'not-allowed')}}
<p><strong>{{{numberToTextTags refillCondition}}} 골드 미만 보유 시</strong></p>
<p><strong>1일 {{totalChances}}회 {{{numberToTextTags refillMoney}}} 골드를 리필 해드립니다.</strong></p>
{{/if}}

{{#if (equal resultText 'fail')}}
<p><strong>{{{numberToTextTags refillCondition}}} 골드 미만 보유 시</strong></p>
<p><strong>1일 {{totalChances}}회 {{{numberToTextTags refillMoney}}} 골드를 리필 해드립니다.</strong></p>
{{/if}}

{{#if (equal resultText 'success')}}
  {{#if (equal refillTypeText 'free')}}
  <p><strong>무료 리필 {{{numberToTextTags refillMoney}}} 골드가 지급되었습니다.</strong></p>
  <p><em>({{remainingChances}}회 남음)</em></p>
  {{/if}}
  {{#if (equal refillTypeText 'howpcbang')}}
  <p><strong>하우PC방 무료 리필 {{{numberToTextTags refillMoney}}} 골드가 지급되었습니다.</strong></p>
  <p><em>({{remainingChances}}회 남음)</em></p>
  {{/if}}
{{/if}}

{{#if (equal resultText 'end')}}
<p><strong>오늘 리필을 모두 받았습니다.</strong></p>
<p><em>※ 리필 횟수는 매일 자정(밤12시)에 재충전됩니다.</em></p>
{{/if}}